var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveCircleOutlineBlack24Dp8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10C7 10.55 7.45 11 8 11H16C16.55 11 17 10.55 17 10C17 9.45 16.55 9 16 9H8C7.45 9 7 9.45 7 10ZM12 0C6.48 0 2 4.48 2 10C2 15.52 6.48 20 12 20C17.52 20 22 15.52 22 10C22 4.48 17.52 0 12 0ZM12 18C7.59 18 4 14.41 4 10C4 5.59 7.59 2 12 2C16.41 2 20 5.59 20 10C20 14.41 16.41 18 12 18Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCircleOutlineBlack24Dp8);
export default __webpack_public_path__ + "static/media/remove_circle_outline_black_24dp 8.90312532e6bb5ca5eeb6e2b5cd44a3bd.svg";
export { ForwardRef as ReactComponent };